'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['line-height:0;> *{transform-origin:center;transition:transform 0.4s cubic-bezier(0.68,-0.55,0.27,1.55);transform:', ';}'], ['line-height:0;> *{transform-origin:center;transition:transform 0.4s cubic-bezier(0.68,-0.55,0.27,1.55);transform:', ';}']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Rotate = _styledComponents2.default.div(_templateObject, function (props) {
  return props.active ? 'rotate(-180deg)' : 'initial';
});

Rotate.displayName = 'Rotate';
Rotate.propTypes = {
  active: _propTypes2.default.bool
};
Rotate.defaultProps = {
  active: false
};

exports.default = Rotate;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../mcs-lite-ui/lib/Rotate/Rotate.js
// module id = 519
// module chunks = 4